import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import architecture from "./architecture";
import fetchReducer from "./FetchReducers";
import flashMessageReducer from "./FlashMessageReducers";
import languages from "./languages";
import loginReducer from "./LoginReducers";
import playerReducer from "./PlayerReducers";
import uploader from "./uploader";
import variableReducer from "./VariableReducers";

import type { ConnectedRouterProps, RouterState } from "connected-react-router";

import type { ArchitectureState } from "./architecture.types";
import type { FetchState } from "./fetch.types";
import type { LanguagesState } from "./languages.types";
import type { LoginState } from "./login.types";
import type { UploaderState } from "./uploader.types";
import type { VariableState } from "./variable.types";

export interface AppState {
  router: RouterState;
  architectureReducer: ArchitectureState;
  flashMessageReducer: unknown;
  loginReducer: LoginState;
  fetchReducer: FetchState;
  variableReducer: VariableState;
  playerReducer: unknown;
  languages: LanguagesState;
  uploader: UploaderState;
}

const createRootReducer = (history: ConnectedRouterProps["history"]) =>
  combineReducers({
    router: connectRouter(history),
    architectureReducer: architecture,
    flashMessageReducer,
    loginReducer,
    fetchReducer,
    variableReducer,
    playerReducer,
    languages,
    uploader,
  });

export default createRootReducer;
